import { Component, Input } from '@angular/core';

export type StatCardVariant = 'kpi' | 'kpi-hero' | 'metric' | 'total';
export type StatCardTone = 'default' | 'success' | 'warning';

@Component({
  selector: 'app-stat-card',
  template: `
    <div class="stat-card" [ngClass]="'stat-card--' + variant">
      <span class="stat-card__label">{{ label }}</span>
      <span class="stat-card__value"
        [ngClass]="[
          'stat-card__value--' + variant,
          tone !== 'default' ? 'stat-card__value--' + tone : ''
        ]">
        {{ value }}
      </span>
    </div>
  `
})
export class StatCardComponent {
  @Input() label = '';
  @Input() value = '';
  @Input() variant: StatCardVariant = 'metric';
  @Input() tone: StatCardTone = 'default';
}
